export default __webpack_public_path__ + "media/titles/title_2_locale_de-4945c490.png";